var map = {
	"./1.png": 1199,
	"./2.png": 4151,
	"./3.png": 3110,
	"./4.png": 9051,
	"./6b1HeN6jaB5B9BcR9h3NaFdG7B.be7be7db.png": 4648,
	"./audit1.png": 9959,
	"./audit2.png": 811,
	"./audit3.png": 4571,
	"./banner.png": 2962,
	"./coinbase.png": 8818,
	"./cs.png": 5716,
	"./defix_box.png": 9803,
	"./eth.png": 3928,
	"./fuzhi.png": 2818,
	"./home_banner.jpg": 3346,
	"./huobi.png": 2593,
	"./lang/cn": 9262,
	"./lang/cn.json": 9262,
	"./lang/en": 5371,
	"./lang/en.json": 5371,
	"./level.png": 158,
	"./logo.jpg": 5096,
	"./logo.png": 6949,
	"./metamask.png": 140,
	"./okx.png": 9715,
	"./share.png": 9300,
	"./share_banner.jpg": 3878,
	"./surbodinate.png": 8893,
	"./team.png": 5135,
	"./tether.png": 5066,
	"./tokenABI": 7089,
	"./tokenABI.json": 7089,
	"./token_pock.png": 226,
	"./trust-wallet.png": 4821,
	"./trust_wallet.png": 2035,
	"./trx.png": 8473,
	"./vip.png": 6133,
	"./wave/wave (10).png": 3599,
	"./wave/wave (2).png": 3918,
	"./wave/wave (3).png": 9294,
	"./wave/wave (4).png": 8532,
	"./wave/wave (5).png": 2061,
	"./wave/wave (6).png": 8219,
	"./wave/wave (7).png": 6384,
	"./wave/wave (8).png": 4331,
	"./wave/wave (9).png": 3850,
	"./wave/wave(1).png": 8860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;